var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.04297,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F04438"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.04297,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D92D20",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 28.3765V33.0431M33 37.7098H33.0117M44.6667 33.0431C44.6667 39.4865 39.4434 44.7098 33 44.7098C26.5567 44.7098 21.3334 39.4865 21.3334 33.0431C21.3334 26.5998 26.5567 21.3765 33 21.3765C39.4434 21.3765 44.6667 26.5998 44.6667 33.0431Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.0dfd32e3c00b2fdb9c292e5726e6ffb5.svg";
export { ForwardRef as ReactComponent };